import QueryKeys from '@src/constants/queryKeys';
import useDeviceWidgetConfig from '@src/hooks/devices/useDeviceWidgetConfig';
import { Device } from '@src/types/Device';
import { WidgetInternalId } from '@src/types/devices/Widget.types';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { useMemo } from 'react';

interface UseDeviceListWidgetOptions {
  currentUnit: Device;
  widgetId: WidgetInternalId;
  isUnitScope?: boolean;
}

const useDeviceListWidget = ({
  currentUnit,
  widgetId,
  isUnitScope = true,
}: UseDeviceListWidgetOptions) => {
  const unitControllerId = currentUnit?.deviceId;
  const unitControllerEngineeringId = currentUnit?.engineeringId;

  const widgetBody = useMemo(
    () =>
      isUnitScope
        ? {
            unitControllerId,
            unitControllerEngineeringId,
          }
        : {},
    [isUnitScope, unitControllerId, unitControllerEngineeringId],
  );

  const {
    data: widgetConfig,
    isLoading: widgetLoading,
    isError: widgetError,
  } = useDeviceWidgetConfig<WidgetTypeDeviceList>({
    internalId: widgetId,
    body: widgetBody,
    enabled: !!currentUnit?.deviceId,
    queryKeys: [QueryKeys.widgetDeviceList, currentUnit?.deviceId ?? ''],
  });

  return {
    widgetConfig,
    isLoading: widgetLoading,
    isError: widgetError,
  };
};

export default useDeviceListWidget;
